import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "scroll",
  class: "bg-gray-100 pt-2 h-full overflow-y-auto"
}
const _hoisted_2 = {
  key: 1,
  class: "p-4 pb-3 mb-2 bg-white rounded-lg h-18 shadow-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_skeleton = _resolveComponent("f-skeleton")!
  const _component_card_lecture = _resolveComponent("card-lecture")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.fetching)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(6, (i) => {
          return _createElementVNode("div", {
            key: i,
            class: "p-4 pb-3 mb-2 bg-white rounded-lg h-18 shadow-lg"
          }, [
            _createVNode(_component_f_skeleton, { width: ['100%', '50%'] })
          ])
        }), 64))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createBlock(_component_card_lecture, {
        key: item.id,
        class: "f-clickable mb-2",
        lecture: item,
        onClick: ($event: any) => (_ctx.$router.push(`/rating/lecture/${item.id}`))
      }, null, 8, ["lecture", "onClick"]))
    }), 128)),
    (_ctx.fetchingMore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_f_skeleton, { width: ['100%', '50%'] })
        ]))
      : _createCommentVNode("", true)
  ], 512))
}